// extracted by mini-css-extract-plugin
export default {"CustomLoading":"CustomLoading_CustomLoading__If-hZ","Inline":"CustomLoading_Inline__qu3Qt","SVG":"CustomLoading_SVG__lQfm2"};